import { render, staticRenderFns } from "./CardMobilePremium.vue?vue&type=template&id=e5c56d84&scoped=true&"
import script from "./CardMobilePremium.vue?vue&type=script&lang=js&"
export * from "./CardMobilePremium.vue?vue&type=script&lang=js&"
import style0 from "./CardMobilePremium.vue?vue&type=style&index=0&id=e5c56d84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c56d84",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5c56d84')) {
      api.createRecord('e5c56d84', component.options)
    } else {
      api.reload('e5c56d84', component.options)
    }
    module.hot.accept("./CardMobilePremium.vue?vue&type=template&id=e5c56d84&scoped=true&", function () {
      api.rerender('e5c56d84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/SelecaoAssinatura/components/mobile/CardMobilePremium.vue"
export default component.exports